const getFallbackInitials = (name: string): string => name[0] ?? '';

export { getFallbackInitials };
